module.exports = __webpack_public_path__ + "static/media/tom.e580ccc5.jpg";